import { Row } from "@tanstack/react-table";
import { PanelListTableBodyRow } from "./panelListTableBodyRow";
import { PanelListElement } from "../../../eventBus/panelListEventPayloads";
import "./panelListContent.css";

export const PanelListTableBody = ({ rows }: { rows: Row<PanelListElement>[] }) => (
    <tbody>
        {rows.map(row => (
            <PanelListTableBodyRow key={row.id} row={row} />
        ))}
    </tbody>
);
